import { Container, Spinner } from "react-bootstrap";

const ContainerSpinner = () => {
  return (
    <Container className="mt-4 mb-4 text-center">
      <Spinner animation="border" />
    </Container>
  );
};

export default ContainerSpinner;
